import React, { useEffect } from "react";
import $ from "jquery";
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import ScrollUp from '../Components/ScrollUp'

export default function About() {

    /* PRIVATE FUNCTIONS */
    useEffect(() => {

        // _onScroll: function(noSmooth) {
        $(window).scroll(function (noSmooth) {
            var scroll = $(document).scrollTop();
            var windowHeight = $(window).height();
            console.log("onScroll " + scroll);
            $("[data-parallax]").each($.proxy(function (index, el) {
                var $el = $(el);
                var properties = [];
                var applyProperties = false;
                var style = $el.data("style");
                if (style === undefined) {
                    style = $el.attr("style") || "";
                    $el.data("style", style);
                }
                var datas = [$el.data("parallax")];
                var iData;
                for (iData = 2; ; iData++) {
                    if ($el.data("parallax" + iData)) {
                        datas.push($el.data("parallax-" + iData));
                    }
                    else {
                        break;
                    }
                }
                var datasLength = datas.length;
                for (iData = 0; iData < datasLength; iData++) {
                    var data = datas[iData];
                    var scrollFrom = data["from-scroll"];
                    if (scrollFrom === undefined) scrollFrom = Math.max(0, $(el).offset().top - windowHeight);
                    scrollFrom = scrollFrom | 0;
                    var scrollDistance = data["distance"];
                    var scrollTo = data["to-scroll"];
                    if (scrollDistance === undefined && scrollTo === undefined) scrollDistance = windowHeight;
                    scrollDistance = Math.max(scrollDistance | 0, 1);
                    var easing = data["easing"];
                    var easingReturn = data["easing-return"];
                    if (easing === undefined || !$.easing || !$.easing[easing]) easing = null;
                    if (easingReturn === undefined || !$.easing || !$.easing[easingReturn]) easingReturn = easing;
                    if (easing) {
                        var totalTime = data["duration"];
                        if (totalTime === undefined) totalTime = scrollDistance;
                        totalTime = Math.max(totalTime | 0, 1);
                        var totalTimeReturn = data["duration-return"];
                        if (totalTimeReturn === undefined) totalTimeReturn = totalTime;
                        scrollDistance = 1;
                        var currentTime = $el.data("current-time");
                        if (currentTime === undefined) currentTime = 0;
                    }
                    if (scrollTo === undefined) scrollTo = scrollFrom + scrollDistance;
                    scrollTo = scrollTo | 0;
                    var smoothness = data["smoothness"];
                    if (smoothness === undefined) smoothness = 10;
                    smoothness = smoothness | 0;
                    if (noSmooth || smoothness === 0) smoothness = 1;
                    smoothness = smoothness | 0;
                    var scrollCurrent = scroll;
                    scrollCurrent = Math.max(scrollCurrent, scrollFrom);
                    scrollCurrent = Math.min(scrollCurrent, scrollTo);
                    if (easing) {
                        if ($el.data("sens") === undefined) $el.data("sens", "back");
                        if (scrollCurrent > scrollFrom) {
                            if ($el.data("sens") === "back") {
                                currentTime = 1;
                                $el.data("sens", "go");
                            }
                            else {
                                currentTime++;
                            }
                        }
                        if (scrollCurrent < scrollTo) {
                            if ($el.data("sens") === "go") {
                                currentTime = 1;
                                $el.data("sens", "back");
                            }
                            else {
                                currentTime++;
                            }
                        }
                        if (noSmooth) currentTime = totalTime;
                        $el.data("current-time", currentTime);
                    }
                    // this._properties.map($.proxy(function (prop) {
                    //     var defaultProp = 0;
                    //     var to = data[prop];
                    //     if (to === undefined) return;
                    //     if (prop === "scale" || prop === "scaleX" || prop === "scaleY" || prop === "scaleZ") {
                    //         defaultProp = 1;
                    //     }
                    //     else {
                    //         to = to | 0;
                    //     }
                    //     var prev = $el.data("_" + prop);
                    //     if (prev === undefined) prev = defaultProp;
                    //     var next = ((to - defaultProp) * ((scrollCurrent - scrollFrom) / (scrollTo - scrollFrom))) + defaultProp;
                    //     var val = prev + (next - prev) / smoothness;
                    //     if (easing && currentTime > 0 && currentTime <= totalTime) {
                    //         var from = defaultProp;
                    //         if ($el.data("sens") === "back") {
                    //             from = to;
                    //             to = -to;
                    //             easing = easingReturn;
                    //             totalTime = totalTimeReturn;
                    //         }
                    //         val = $.easing[easing](null, currentTime, from, to, totalTime);
                    //     }
                    //     val = Math.ceil(val * this.round) / this.round;
                    //     if (val === prev && next === to) val = to;
                    //     if (!properties[prop]) properties[prop] = 0;
                    //     properties[prop] += val;
                    //     if (prev !== properties[prop]) {
                    //         $el.data("_" + prop, properties[prop]);
                    //         applyProperties = true;
                    //     }
                    // }, this));
                }
                if (applyProperties) {
                    if (properties["z"] !== undefined) {
                        var perspective = data["perspective"];
                        if (perspective === undefined) perspective = 800;
                        var $parent = $el.parent();
                        if (!$parent.data("style")) $parent.data("style", $parent.attr("style") || "");
                        $parent.attr("style", "perspective:" + perspective + "px; -webkit-perspective:" + perspective + "px; " + $parent.data("style"));
                    }
                    if (properties["scaleX"] === undefined) properties["scaleX"] = 1;
                    if (properties["scaleY"] === undefined) properties["scaleY"] = 1;
                    if (properties["scaleZ"] === undefined) properties["scaleZ"] = 1;
                    if (properties["scale"] !== undefined) {
                        properties["scaleX"] *= properties["scale"];
                        properties["scaleY"] *= properties["scale"];
                        properties["scaleZ"] *= properties["scale"];
                    }
                    var translate3d = "translate3d(" + (properties["x"] ? properties["x"] : 0) + "px, " + (properties["y"] ? properties["y"] : 0) + "px, " + (properties["z"] ? properties["z"] : 0) + "px)";
                    var rotate3d = "rotateX(" + (properties["rotateX"] ? properties["rotateX"] : 0) + "deg) rotateY(" + (properties["rotateY"] ? properties["rotateY"] : 0) + "deg) rotateZ(" + (properties["rotateZ"] ? properties["rotateZ"] : 0) + "deg)";
                    var scale3d = "scaleX(" + properties["scaleX"] + ") scaleY(" + properties["scaleY"] + ") scaleZ(" + properties["scaleZ"] + ")";
                    var cssTransform = translate3d + " " + rotate3d + " " + scale3d + ";";
                    console._log(cssTransform);
                    // console.log(function (cssTransform){})
                    $el.attr("style", "transform:" + cssTransform + " -webkit-transform:" + cssTransform + " " + style);
                }
            }, this));
            // if ($(window).requestAnimationFrame) {
            //     $(window).requestAnimationFrame($.proxy(this._onScroll, this, false));
            // }
            // else {
            //     $(window).requestAnimationFrame($.proxy(this._onScroll, this, false));
            // }
        })

    }, []);

    return (
        <>
            <section id="scroll-up">

                {/* <!-- back-to-top-start  --> */}
                <ScrollUp />
                {/* <!-- back-to-top-end  --> */}

                <Header />

                <div id="smooth-wrapper">
                    <div id="smooth-content">

                        <main>

                            {/* <!-- tp-breadcrumb-area-start --> */}
                            <div className="about-banner-area p-relative">
                                <div className="about-shape-1 z-index-3">
                                    <img src="/img/breadcrumb/breadcrumb-shape-1.png" alt="" />
                                </div>
                                <div className="about-shape-2 z-index-3">
                                    <img src="/img/breadcrumb/breadcrumb-shape-2.png" alt="" />
                                </div>
                                <div className="about-banner p-relative z-index fix">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className="about-banner-content z-index-5">
                                                    <h4 className="about-banner-title" data-parallax='{"y": 1000, "smoothness": 10}'>
                                                        <span>About</span> <br />
                                                        <span>Billwale</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- tp-breadcrumb-area-end --> */}

                            {/* <!-- tp-breadcrumb-header-area-start --> */}
                            <div className="about-img-area mb-100 z-index-3">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="about-img about-img-height p-relative"
                                                data-background="/img/breadcrumb/breadcrumb-2.jpg" style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb-2.jpg)" }} >
                                                <div className="about-img-content">
                                                    <h4 className="about-img-title" data-parallax='{"y": 1000, "smoothness": 10}'>
                                                        <span>About</span> <br />
                                                        <span>Billwale</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- tp-breadcrumb-header-area-end --> */}

                            {/* <!--ab-company-area-start --> */}
                            <div className="ab-company-area">
                                <div className="container">

                                    <div className="row ab-company-section-space">
                                        <hr />
                                        <div className="col-xl-6">
                                            <div className="ab-company-section-box">
                                                <h3 className="tp-section-title">About Us <br /></h3>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 wow tpfadeRight" data-wow-duration=".9s" data-wow-delay=".5s">
                                            <div className="ab-company-right">
                                                <div className="ab-company-section-text">
                                                    <p>Billwale is a FREE Business Accounting Software built for Indian small
                                                        businesses to deal with invoicing, inventory, accounting needs, and much more! The goal
                                                        is to make a businessman’s daily routine less tiring and let them focus more on growing
                                                        their business, less on paperwork.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                    </div>

                                    {/* <!-- tp-card-area-start --> */}
                                    <div className="tp-card-area tp-card-space">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 wow tpfadeLeft" data-wow-duration=".9s" data-wow-delay=".5s">
                                                    <div className="tp-card-thumb-wrapper p-relative">
                                                        <div className="tp-card-main-img">
                                                            <img src="/img/card/Billwale-Banner.png" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-6 wow tpfadeRight" data-wow-duration=".9s" data-wow-delay=".7s">
                                                    <div className="tp-card-title-box">
                                                        <h3 className="tp-section-title-3 pb-15 fs-1">Small/Medium <span> Business</span> </h3>
                                                        <p className="pb-10">Even today, 70% SMEs in India still create bills on paper. Being that,
                                                            most of their productive time is consumed in making manual entries and calculations.
                                                            When small things go wrong, the entire business goes down, simply because there is
                                                            no
                                                            place to fall back. Not having the resources can really wear out the business owner
                                                            driving them away from doing what matters most. Small Business Accounting Software
                                                            needs a Digital Upgrade. An upgrade that is simple yet effcient. We are trying to
                                                            bring
                                                            in a simpler solution that works for them and hence Billwale.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- tp-card-area-end --> */}

                                    {/* <!-- tp-sales-area-start --> */}
                                    <div className="tp-sales-area tp-sales-space">
                                        <div className="container">
                                            <div className="row align-items-center">
                                                <div className="col-xl-6 col-lg-6 wow tpfadeLeft" data-wow-duration=".9s" data-wow-delay=".5s">
                                                    <div className="tp-sales-section-box">
                                                        <h3 className="tp-section-title-3 pb-15 fs-1"><span>With Billwale,
                                                        </span>a Businessman can effortlessly.</h3>
                                                    </div>
                                                    <p className="pb-10">Become GST compatible.
                                                        Manage all parties in one single place and market business much easily.
                                                        View how business is performing instantly.
                                                        Create, print/share customized invoices.
                                                        Set up “Auto Backup” and secure his business accounting data against accidental data
                                                        loss.
                                                        Expired items can be easily selected for upcoming sale by simply tracking individual
                                                        units of the item by batch numbers.
                                                        Set automatic payment reminders.
                                                        Do business accounting software offline without internet.</p>
                                                </div>
                                                <div className="tp-sales-right col-xl-6 col-lg-6 wow tpfadeRight" data-wow-duration=".9s"
                                                    data-wow-delay=".7s">
                                                    <div className="tp-sales-img-wrapper about_img p-relative ps-5">
                                                        <img src="/img/card/about_img.png" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- tp-sales-area-end --> */}

                                </div>
                            </div>
                            {/* <!--ab-company-area-end --> */}

                            {/* <!-- tp-about-area-start --> */}
                            <div className="tp-about__area tp-about__pt-pb pb-160">
                                <div className="container">
                                    <div className="row align-items-center">
                                        <div className="col-xl-6 col-lg-6 wow tpfadeLeft" data-wow-duration=".9s" data-wow-delay=".2s">
                                            <div className="tp-about__img-wrapper text-center text-lg-end p-relative">
                                                <div className="tp-about__bg-shape">
                                                    <img src="/img/about/about-bg-shape.png" alt="" />
                                                </div>
                                                <div className="tp-about__main-img z-index">
                                                    <img src="/img/about/about-2.jpg" alt="" />
                                                </div>
                                                <div className="tp-about__sub-img-1 d-none d-sm-block z-index-3">
                                                    <img src="/img/about/about-1.jpg" alt="" />
                                                </div>
                                                <div className="tp-about__sub-img-2 d-none d-sm-block">
                                                    <img src="/img/about/about-3.jpg" alt="" />
                                                </div>
                                                <div className="tp-about__sub-img-3 d-none d-sm-block z-index-3">
                                                    <img src="/img/about/about-5.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 wow tpfadeRight" data-wow-duration=".9s" data-wow-delay=".6s">
                                            <div className="tp-about__right">
                                                <div className="tp-about__section-box">
                                                    <h4 className="tp-section-subtitle">OVER 150K+ CLIENT</h4>
                                                    <h3 className="tp-section-title mb-15">We Offer Real Time Data Solutions
                                                    </h3>
                                                    <p>Excepteur sint occaecat cupidatat officia non proident <br />
                                                        sunt in culpa qui deserunt.!</p>
                                                </div>
                                                <div className="tp-about__list">
                                                    <ul>
                                                        <li><i className="fal fa-check"></i>Various analysis options.</li>
                                                        <li><i className="fal fa-check"></i>Page Load (time, size, number of requests).</li>
                                                        <li><i className="fal fa-check"></i>Big data analysis.</li>
                                                    </ul>
                                                </div>
                                                <div className="tp-about__btn">
                                                    <a className="tp-btn tp-btn-inner tp-btn-hover alt-color-black" href="about.html">
                                                        <span>About Us</span>
                                                        <b></b>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- tp-about-area-end --> */}

                        </main>

                        <Footer />

                    </div>
                </div>
            </section>
        </>
    )
}
